var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartBarHorizontal01 = function SvgChartBarHorizontal01(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H4M13 9V4.6001C13 4.04005 12.9996 3.75981 12.8906 3.5459C12.7948 3.35774 12.6429 3.20487 12.4548 3.10899C12.2409 3 11.9601 3 11.4 3H4V9M13 9H18.4C18.9601 9 19.2409 9 19.4548 9.10899C19.6429 9.20487 19.7948 9.35774 19.8906 9.5459C19.9996 9.75981 20 10.04 20 10.6001V13.4001C20 13.9601 19.9996 14.2398 19.8906 14.4537C19.7948 14.6419 19.6429 14.7952 19.4548 14.8911C19.2411 15 18.961 15 18.402 15H16M4 9V15M4 15V21H14.402C14.961 21 15.2411 21 15.4548 20.8911C15.6429 20.7952 15.7948 20.642 15.8906 20.4538C15.9996 20.2399 16 19.9601 16 19.4V15M4 15H16",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartBarHorizontal01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chart_Bar_Horizontal_01.0795161b.svg";
export { ForwardRef as ReactComponent };